export default "__VITE_ASSET__CHCWM4lg__"